.root {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.original {
  color: var(--color-text-subtle);
  font-size: var(--text-xs);
  text-decoration: none;
}

.version {
  color: inherit;
}

.original:hover,
.version:hover {
  text-decoration: underline;
}
